import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetPlaceOrder, checkCouponCode,myorders } from "../../src/services/Apis";
import { useSelector } from "react-redux";

export const GetPlaceOrderapi = createAsyncThunk("fetchGetPlaceOrderdata", async (input_data) => {
    const res = await GetPlaceOrder(input_data);
    return res;
});
export const checkCouponCodeapi = createAsyncThunk("fetchcheckCouponCodedata", async (input_data) => {
    const res = await checkCouponCode(input_data);
    return res;
});



const paymentslice = createSlice({
    name: "cartslice",
    initialState: {
        loading: false,
        error: null,
        paymentmethodsdata: [],
        coupanmsg: "",
        donationfee: "",
        showdonation: true,
        selecteddefaultpaymentmethod: {},
        selecteddeafultoption: []
    },
    reducers: {
        setdonationfee: (state, action) => {
            state.donationfee = action.payload;
        },
        setpaymentmethodsdata: (state, action) => {
            state.paymentmethodsdata = action.payload;
        },
        setshowdonation: (state, action) => {
            state.showdonation = action.payload;
        },
        setselecteddefaultpaymentmethod: (state, action) => {
            state.selecteddefaultpaymentmethod = action.payload;
        },
        setselecteddeafultoption: (state, action) => {
            state.selecteddeafultoption = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            //....................place order
            .addCase(GetPlaceOrderapi.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetPlaceOrderapi.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentmethodsdata = action.payload.data;
                if (action.payload.status === "success") {
                    state.donationfee = action.payload.data.donation;
                    state.selecteddefaultpaymentmethod = action.payload.data.payment_method.find(m => m.selected).id;
                }
            })
            .addCase(GetPlaceOrderapi.rejected, (state, action) => {
                state.loading = false;
            })

            //......................coupancode
            .addCase(checkCouponCodeapi.fulfilled, (state, action) => {
                if (action.payload.status === "success") {
                    state.coupanmsg = action.payload.data.msg;
                }
            })
         

    }
})
export const { setdonationfee, setshowdonation, setselecteddefaultpaymentmethod, setselecteddeafultoption,setpaymentmethodsdata } = paymentslice.actions
export default paymentslice.reducer;
